<template>
  <div id="learn">
    <Learn0 v-if="$route.path == '/learn'" :sampleName="sampleNames[0]"/>
    <Learn1 v-if="$route.query.learn == 1 && hidePlusTasks" :sampleName="sampleNames[1]"/>
    <Learn2 v-if="$route.query.learn == 2"/>
    <Learn3 v-if="$route.query.learn == 3" :sampleName="lastTask && lastTask.name"/>
    <Learn4 v-if="$route.query.learn == 4"/>
    <cookie-consent :message="message" :linkLabel="linkLabel" :buttonLabel="buttonLabel"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Arrow from '../../misc/Arrow';
    import Learn0 from './Learn0.vue'
    import Learn1 from './Learn1.vue'
    import Learn2 from './Learn2.vue'
    import Learn3 from './Learn3.vue'
    import Learn4 from './Learn4.vue'

export default {
    name: 'LearnStep',
     components:{
         Learn4,
            Learn3,
            Learn2,
            Learn1,
            Learn0,
           Arrow,
      },
    props: ['hidePlusTasks'],
    data() {
      return {
        sampleNames:[
          'Кулинария',
          'Закуски'
        ],
        message: "Этот веб-сайт использует файлы cookie, чтобы обеспечить вам наилучший опыт работы на нашем веб-сайте.",
        linkLabel: "Узнать подробнее",   
        buttonLabel: "Ясно"
      }
    },
    computed:{
        ...mapGetters(['themes', 'lastTask']),
    },
    methods: {
      ...mapActions(['addTheme','saveOrderThemes','setLearned']),
    },
}
</script>

<style lang="scss" scoped>
$bkg-welcome: linear-gradient(180deg, #EEF8FF 0%, #DEFFEF 100%);
$bkg-steps: rgba(87, 87, 87, 0.9);
$clr-white: #FFFFFF;


</style>

<style lang="scss">
$bkg-welcome: linear-gradient(180deg, #EEF8FF 0%, #DEFFEF 100%);
$bkg-steps: rgba(87, 87, 87, 0.9);
$clr-white: #FFFFFF;

#learn {
  .background-steps {
      background: $bkg-steps;
  }
 

  // .button-add {
  //   position:fixed;
  //   left:3%;
  //   bottom: 3%;
  //   background: #FFFFFF;
  //   filter: drop-shadow(0px 1px 23px #FFFFFF);
  //   .icon_add {
  //     background-clip: content-box;
  //     background-color:#18A0FB;;
  //     border-radius: 100%;
  //     color:#FFFFFF;
  //     z-index: 1000;
  //   }
  // }
  // .arrow {
  //   left:5%;
  //   bottom: 5%;
  // }
}
button[disabled="disabled"] {
    opacity: .8;
}

</style>